import { underlineLinkStyle } from '@bingads-webui-campaign-react/common-styles';

export const bulkEditStyle = ({ palette = {} }) => ({
  '& .previewTable': {
    overflowY: 'scroll',
    margin: '5px 0 !important',
    maxHeight: 250,
    display: 'inline-block',
    minWidth: 500,
    width: 'auto !important',
  },
  '& .previewTable > table': {
    width: '100%',
    border: '1px solid #CCCCCC',
  },
  '& .bulk-edit-progress-bar': {
    maxWidth: 750,
    width: '50%',
  },
  '& .form-group .bulk-edit-currency': {
    fontWeight: 'normal',
  },
  '& .form-inline .bulkEdit-bid': {
    textAlign: 'right',
    width: '5em',
  },
  '& .bulkEdit-units': {
    marginLeft: 4,
  },
  '& .bulkEdit-limit-label': {
    marginRight: 16,
    paddingLeft: 40,
  },
  '& .bulkeditlink': {
    marginBottom: 5,
    ...underlineLinkStyle({ palette }),
  },
  '& .bulkeditdate': {
    marginBottom: 5,
  },
  '& .bulkedit-info-text': {
    marginBottom: 10,
  },
});
